import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SelectBusiness from "./PriceComponent/SelectBsiness";
import { categories } from "./PriceComponent/category";

const Price = () => {
  const [selectedService, setSelectedService] = useState(null);
  const navigate = useNavigate();

  const handleStep1Next = (label) => {
    setSelectedService(label);

    // Find selected category data
    const selectedCategory = categories.find((item) => item.label === label);

    // Check if it's one of the ordering ones
    if (
      selectedCategory &&
      (selectedCategory.label === "Restaurants" ||
        selectedCategory.label === "Take a way" ||
        selectedCategory.label === "Night Market")
    ) {
      navigate("/price/price-ordering");
    } else {
      navigate("/price/price-booking");
    }
  };

  return (
    <>
      <SelectBusiness onNext={handleStep1Next} />
    </>
  );
};

export default Price;
